//import { Video } from "@/types/video";

import Modal from "components/Modal/Modal";
import { useLang } from "hooks/useLang";
import dynamic from "next/dynamic";
//import ReactPlayer from "react-player";
import { ShortsVideo } from "types/event";
import { useRouter } from "next/router"


interface Props {
  video: ShortsVideo;
  onClose: () => void;
}

const ReactPlayer = dynamic(() => import("react-player"), { ssr: false });

export default function VideoModal({ video, onClose }: Props) {
  const { t } = useLang()
  const router = useRouter()
  return (
    <Modal
      isOpen={true}
      //@ts-ignore
      onAfterOpen={() => {
        document.body.style.overflow = "hidden"
      }}
      onAfterClose={() => {
        document.body.style.overflow = "unset"
      }}
      contentLabel="Delete User Account Area"
      ariaHideApp={false}
    // style={customStyles}
    >


      <div className="relative bg-white rounded-xl shadow-lg w-full max-w-3xl max-h-[75vh] flex flex-col md:flex-row overflow-hidden">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-2xl font-bold text-gray-700"
          aria-label="Close"
        >
          ×
        </button>




        {/* Video Section */}
        <div className="relative w-full md:w-1/2 bg-black">
          <ReactPlayer
            src={video.url}
            controls
            playing
            playsInline
            preload="auto"
            //className="w-full h-full object-cover"
            height={"100%"}
            width={"100%"}
          //className="w-full h-full"
          // config={{
          //   file: {
          //     attributes: {
          //       style: { objectFit: "cover" },
          //     },
          //   },
          // }}
          />
        </div>

        {/* Content Section */}
        <div className="w-full md:w-1/2 p-6 overflow-y-auto">
          <div className="text-lg font-semibold mb-3">{video.performer}</div>
          {video?.event ? <div className="absolute bottom-3 right-4">

            <button
              onClick={() => router.push(`/events/${video?.event}`)}
              className=" top-3 right-4 text-xxl font-bold text-white-700 bg-mint-green-500 hover:bg-mint-green-600 p-2 px-5  rounded-full"
              aria-label="Close"
            >
              {t("go_to_event")}
            </button>
          </div> : false}
          <ul className="space-y-2 text-sm text-gray-700">
            {video.hashtags.map((tag, i) => (
              <li key={i}>{tag}</li>
            ))}
          </ul>
        </div>
      </div>
    </Modal>
  );
}
